import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
 
import { Timeline } from './timeline.component';
 
import { MatButtonModule} from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { GraphDetailModule } from '../graph-detail/graph-detail.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DocumentViewerModule } from '../document-viewer/document-viewer.module';
 
@NgModule({
  declarations: [
    Timeline
  ],
  imports: [
    BrowserModule,
    FormsModule,
    DocumentViewerModule,
    GraphDetailModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatMenuModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule
  ],
  exports: [
    Timeline
  ],
  providers: [],
})
export class TimelineModule { }